// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"339c8aee","219":"296b4a7c","397":"5c82954d","455":"399606b7","555":"a4ff575d","797":"16a6b632","852":"efabf713","936":"8b8a5736","977":"8c72bf08"}[chunkId] + ".chunk.js";
};